import { render, staticRenderFns } from "./menuTabRender.vue?vue&type=template&id=58814f72&scoped=true"
import script from "./menuTabRender.vue?vue&type=script&lang=js"
export * from "./menuTabRender.vue?vue&type=script&lang=js"
import style0 from "./menuTabRender.vue?vue&type=style&index=0&id=58814f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58814f72",
  null
  
)

export default component.exports